<mat-card>
    <mat-card-header>
        <mat-card-title><h2>Pre-work checks</h2></mat-card-title>
        <mat-card-subtitle>Configure the tenant-wide Vehicle Check shown to engineers before operational work.</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        @if (loading) {
            <p class="text-muted">Loading pre-work settings…</p>
        } @else if (loadFailed) {
            <div class="alert alert-danger" role="alert">Unable to load pre-work settings. Please try again.</div>
        } @else {
            <form [formGroup]="form" (ngSubmit)="save()">
                <section class="row gy-3">
                    <div class="col-12">
                        <h3 class="mb-1">Vehicle Check</h3>
                        <p class="text-muted mb-3">This check is global: one completed check covers the engineer across all Sites for that device-local day.</p>
                        <mat-slide-toggle color="primary" formControlName="vehicle_check_enabled">Enable Vehicle Check</mat-slide-toggle>
                    </div>

                    <mat-form-field class="col-12 col-lg-6" appearance="outline">
                        <mat-label>Vehicle Check form</mat-label>
                        <mat-select formControlName="vehicle_check_form_id">
                            <mat-option [value]="null">Select a form</mat-option>
                            @for (formOption of vehicleCheckForms; track formOption.id) {
                                <mat-option [value]="formOption.id">{{ formOption.title }}</mat-option>
                            }
                        </mat-select>
                        @if (!vehicleCheckForms.length) {
                            <mat-hint>No Vehicle Check forms are available. Create one in the Form Builder first.</mat-hint>
                        }
                        @if (form.controls.vehicle_check_form_id.hasError('required')) {
                            <mat-error>Select a Vehicle Check form before enabling the check.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="col-12 col-lg-6" appearance="outline">
                        <mat-label>Enforcement</mat-label>
                        <mat-select formControlName="enforcement">
                            <mat-option value="block">Block operational work</mat-option>
                            <mat-option value="warn">Warn and allow engineers to continue</mat-option>
                        </mat-select>
                        <mat-hint>Site Visit enforcement is configured separately on each Site.</mat-hint>
                    </mat-form-field>

                    <div class="col-12" *appCan="'edit_settings'">
                        <button mat-raised-button color="primary" type="submit" [disabled]="saving || form.invalid">
                            {{ saving ? 'Saving…' : 'Save Vehicle Check settings' }}
                        </button>
                    </div>
                </section>
            </form>
        }
    </mat-card-content>
</mat-card>
